import React from 'react';
import { Box, Text } from '@common-fe/common-fe';

export interface Props {
  testId?: string;
  subText?: string;
}
const PlaceholderBaseSearching: React.FC<Props> = ({ subText, testId = 'placeholder' }) => {
  return (
    <Box direction="column" align="center" justify="center">
      <Text data-testid={`${testId}_text`} size="large" margin={{ top: 'spacing24' }} weight={700}>
        No data found
      </Text>
      <Text weight={400}>You can currently search only by next columns:</Text>
      <Text weight={400}>
        {subText || 'Subsidiary Name, First Name, Last Name, SSN, or Partner/Employer Employee ID.'}
      </Text>
    </Box>
  );
};

export default PlaceholderBaseSearching;
